<template>
    <div class="max-w-screen-2xl mx-auto">
        <Content
            v-if="preview"
            model="page"
            :content="content"
            :api-key="apiKey" 
            :custom-components="REGISTERED_COMPONENTS"
        />
  </div>
</template>

<script setup lang="ts">
import { REGISTERED_COMPONENTS } from '~/builder-page.ts';
import { Content, fetchOneEntry } from '@builder.io/sdk-vue'

const apiKey = useAppConfig().builderKey
const route = useRoute()
const { data: content } = await useAsyncData(
    () => `builder-page-${route.path}`,
    async () => {
        try {
            return await fetchOneEntry({
                model: 'page',
                apiKey: apiKey,
                includeUnpublished: true,
                userAttributes: {
                    urlPath: route.path,
                },
            })
        } catch (error) {
            // SDK v3+ throws on non-success responses. Previously this returned null.
            console.error('Failed to load Builder page', error)
            return null
        }
    },
)

const preview = computed(() => {
    return content !== null || window.location.search.indexOf("builder.frameEditing=") !== -1
})


</script>